import { Button } from 'components/Input/Button';
import Typography from 'components/Typography';
import styled, { keyframes } from 'styled-components';

const slideUp = keyframes`
from {
  transform: translateY(10px);
  opacity: 0;
  }
  to {
  transform: translateY(0);
  opacity: 1;
  }
`;

export const HandRaiserContainer = styled.div`
  position: fixed;
  bottom: ${({ theme }) => `calc(${theme.spacing['8Xl']})`};
  right: ${({ theme }) => theme.spacing['xl']};
  z-index: ${({ theme }) => theme._ui.chatPanel.zIndex};
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  box-sizing: border-box;
  max-width: 340px;
  min-width: 340px;
  padding: ${({ theme }) => theme.spacing.xl};
  color: ${({ theme }) => theme.text.inverse};
  font-size: ${({ theme }) => theme.fontSize[200]};
  background-color: ${({ theme }) => theme.background.strong};
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  animation: ${slideUp} 0.25s ease-in-out;
  @media (max-width: ${({ theme }) => theme.breakpoint.sm}) {
    min-width: unset;
    max-width: 100%;
    width: calc(100% - ${({ theme }) => theme.spacing['3Xl']});
    z-index: ${({ theme }) => theme._ui.chatPanel.zIndex + 1};
    margin: 0 auto;
    bottom: ${({ theme }) => theme.spacing['xl']};
    right: ${({ theme }) => theme.spacing['xl']};
  }
`;

export const HandRaiserTextContainer = styled.div`
  line-height: 20px !important;
  font-family: ${({ theme }) => theme.fontFamily.inter}, Arial, Helvetica, sans-serif !important; // otherwise overridden by Brandon Font on deployed environments
  width: 100%;
`;

export const HandRaiserText = styled(Typography).attrs({
  as: 'h4',
  size: 'sm',
  color: 'inverse',
})`
  margin: 0 !important;
  max-width: 215px;
  box-sizing: content-box;
  padding-right: ${({ theme }) => theme.spacing['2Xl']};
  font-weight: 400;

  &::first-letter {
    text-transform: capitalize;
  }
`;

export const HandRaiserCloseWrapper = styled.div`
  position: absolute;
  top: ${({ theme }) => theme.spacing.xl};
  right: ${({ theme }) => theme.spacing.xl};
  padding: ${({ theme }) => theme.spacing.sm};
  border-radius: ${({ theme }) => theme.borderRadius.round};
  display: flex;
  justify-content: flex-end;
  width: auto;
  svg {
    cursor: pointer;
  }

  &:hover {
    background-color: ${({ theme }) => theme.background.default};
    color: ${({ theme }) => theme.text.strong};
  }
`;

export const AvatarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: auto;
  padding-right: ${({ theme }) => theme.spacing.xl};
`;

export const ChatNowButton = styled(Button).attrs({
  size: 'small',
  variant: 'inverse',
})`
  padding: 10px ${({ theme }) => theme.spacing.xl};
  width: 100%;
  height: unset;
  border-radius: ${({ theme }) => theme.borderRadius.md};
  margin: ${({ theme }) => theme.spacing.md} 0 0;
`;
